import type { Product } from '@noths/polaris-dev-ts-types';

const MAX_ITEMS_TO_SEND_TO_RR = 15;

export const getProductCodesFromPlacementItem = (items: Product[]) =>
  items.slice(0, MAX_ITEMS_TO_SEND_TO_RR).map(({ code }) => code);
